import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import { useDetailUserProfile, useUpdateUserProfile } from "hooks";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import { userProfileModeList } from "./utils";
import { getPhoneValidation } from "constants/validate";

const DetailUserProfile = props => {
  const {
    isOpenModal,
    dataDetail,
    toggleModal,
    mode,
    userProfileRoleList,
    userProfileEmailDomainList,
  } = props;

  const { t, i18n } = useTranslation(["userProfile"]);
  const { addToast } = useToasts();

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const getInitDefaultValues = () => {
    return {
      display_name: "",
      user_name: "",
      email_domain: "",
      email: "",
      phone: "",
      user_role: [],
    };
  };

  const getInitControlFields = () => {
    return {
      display: {
        display_name: false,
        user_name: false,
        email: false,
        phone: false,
        user_role: false,
        btn_save: false,
      },
      disabled: {
        display_name: false,
        user_name: false,
        email_domain: false,
        email: false,
        phone: false,
        user_role: false,
      },
    };
  };
  const [controlFields, setControlFields] = useState(getInitControlFields);

  const schema = yup.object().shape({
    display_name: yup
      .string()
      .required(t("form.validate.required", { title: t("form.display_name") }))
      .max(250, t("form.validate.char_max", { max: 250 })),
    user_name: yup
      .string()
      .required(t("form.validate.required", { title: t("form.user_name") }))
      .matches(/^[a-z0-9.]*$/, t("form.validate.email_prefix"))
      .max(50, t("form.validate.char_max", { max: 50 })),
    email_domain: yup
      .string()
      .required(t("form.validate.select", { title: t("form.email_domain") })),
    email: yup
      .string()
      .required(t("form.validate.required", { title: t("form.email") }))
      .email(t("form.validate.invalid", { title: t("form.email") }))
      .max(50, t("validate.char_max", { max: 50 })),
    phone: yup
      .string()
      .nullable()
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    user_role: yup.array().min(
      1,
      t("form.validate.select", {
        title: t("form.user_role"),
      })
    ),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: getInitDefaultValues(),
  });

  // Detail User Profile
  const onSuccessDetailUserProfile = data => {
    reset(getInitDefaultValues());

    setValue("display_name", data.display_name || "", { shouldValidate: true });
    setValue("phone", data.phone || "", { shouldValidate: true });
    setValue("email", data.email || "", { shouldValidate: true });

    if (data.ext_value?.roles?.length > 0) {
      setValue("user_role", data.ext_value.roles, { shouldValidate: true });
    }

    if (data.username) {
      const arrUserName = data.username.split("@");
      setValue("user_name", arrUserName[0], { shouldValidate: true });
      setValue("email_domain", `@${arrUserName[1]}`, { shouldValidate: true });
    }

    switch (mode) {
      case userProfileModeList.VIEW_USER_PROFILE_DETAIL:
        setControlFields({
          display: {
            ...getInitControlFields().display,
            display_name: true,
            user_name: true,
            email: true,
            phone: true,
            user_role: true,
          },
          disabled: {
            ...getInitControlFields().disabled,
            display_name: true,
            user_name: true,
            email_domain: true,
            email: true,
            phone: true,
            user_role: true,
          },
        });
        break;
      case userProfileModeList.EDIT_USER_PROFILE_DETAIL:
        setControlFields({
          display: {
            ...getInitControlFields().display,
            display_name: true,
            user_name: true,
            email: true,
            phone: true,
            user_role: true,
            btn_save: true,
          },
          disabled: {
            ...getInitControlFields().disabled,
            // display_name: true,
            user_name: true,
            email_domain: true,
            // email: true,
          },
        });
        break;
      default:
        break;
    }
  };
  const {
    isLoading: isLoadingDetail,
    data: userProfileDetail,
    refetch: detailUserProfile,
    remove: resetDetailUserProfile,
  } = useDetailUserProfile(
    { userProfileId: dataDetail?.userProfileId, params: {} },
    onSuccessDetailUserProfile
  );

  // Update User Profile
  const onSuccessUpdateUserProfile = _data => {
    toggleModal(mode);
  };
  const onErrorUpdateUserProfile = error => {
    if (error.code === 422 && error.fields.length > 0) {
      error.fields.forEach(item => {
        let fieldName = item.field;
        switch (item.field) {
          case "common":
            addToast(item.message, {
              appearance: "error",
              autoDismiss: true,
            });
            break;
          default:
            break;
        }
        setError(fieldName, {
          type: "manual",
          message: formConvertErrorMessage(item.message, t),
        });
      });
    }
    if (error.code !== 422) {
      toggleModal(mode);
    }
  };
  const { isLoading: isLoadingUpdate, mutate: updateUserProfile } =
    useUpdateUserProfile(onSuccessUpdateUserProfile, onErrorUpdateUserProfile);

  useEffect(() => {
    if (!isOpenModal) {
      resetDetailUserProfile();
      setIsDetail(false);
      setControlFields(getInitControlFields());
      reset(getInitDefaultValues());
    }
  }, [isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.userProfileId && !isDetail) {
        detailUserProfile();
        setIsDetail(true);
      }
    }
  }, [dataDetail, detailUserProfile, isDetail, isOpenModal]);

  const onSubmit = values => {
    const data = getValues();

    switch (mode) {
      case userProfileModeList.EDIT_USER_PROFILE_DETAIL:
        updateUserProfile({
          userProfileId: userProfileDetail?.id,
          data: {
            display_name: data.display_name,
            // username: String(
            //   `${data.user_name}${data.email_domain}`
            // ).toLowerCase(),
            roles: data.user_role,
            email: data.email,
            phone: data.phone,
          },
        });
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <ModalHeader toggle={toggleModal}>
          {mode === userProfileModeList.VIEW_USER_PROFILE_DETAIL &&
            `${t("title.detail")}`}
          {mode === userProfileModeList.EDIT_USER_PROFILE_DETAIL &&
            `${t("title.edit")}`}
        </ModalHeader>
        {isLoadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="4"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Row className="row-cols-1 row-cols-md-2">
                {controlFields.display.display_name && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="display_name">
                        {t("form.display_name")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <input
                        type="text"
                        disabled={controlFields.disabled.display_name}
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "display_name"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.display_name"),
                        })}
                        {...register("display_name")}
                      />
                      {errors.display_name && (
                        <MessageFormValidate
                          error={errors.display_name.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.email && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="email">
                        {t("form.email")} <span className="text-danger">*</span>
                      </Label>
                      <input
                        type="text"
                        disabled={controlFields.disabled.email}
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "email"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.email"),
                        })}
                        {...register("email")}
                      />
                      {errors.email && (
                        <MessageFormValidate error={errors.email.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.phone && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="phone">{t("form.phone")}</Label>
                      <input
                        type="text"
                        disabled={controlFields.disabled.phone}
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "phone"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.phone"),
                        })}
                        {...register("phone")}
                      />
                      {errors.phone && (
                        <MessageFormValidate error={errors.phone.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.user_name && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="user_name">
                        {t("form.user_name")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <div className="input-group">
                        <input
                          type="text"
                          disabled={controlFields.disabled.user_name}
                          className={`form-control ${formValidate(
                            errors,
                            touchedFields,
                            "user_name"
                          )}`}
                          placeholder={t("placeholder.enter", {
                            title: t("form.user_name"),
                          })}
                          {...register("user_name")}
                        />

                        <select
                          className={`form-select ${formValidate(
                            errors,
                            touchedFields,
                            "email_domain"
                          )}`}
                          style={{ maxWidth: "250px", fontWeight: 900 }}
                          disabled={controlFields.disabled.email_domain}
                          {...register("email_domain")}
                        >
                          {userProfileEmailDomainList?.items?.length > 0 &&
                            userProfileEmailDomainList.items.map(item => (
                              <option key={item} value={`@${item}`}>
                                {`@${item}`}
                              </option>
                            ))}
                        </select>
                      </div>
                      {errors.user_name && (
                        <MessageFormValidate error={errors.user_name.message} />
                      )}
                      {errors.email_domain && (
                        <MessageFormValidate
                          error={errors.email_domain.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                )}
              </Row>
              {controlFields.display.user_role && (
                <Row className="row-cols-1 mb-3">
                  <Col>
                    <FormGroup>
                      <Label htmlFor="user_role">
                        {t("form.user_role")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                    </FormGroup>
                  </Col>
                  {userProfileRoleList?.items?.length > 0 && (
                    <Col>
                      <Card className="border-1 border-primary mb-1">
                        <CardBody>
                          <Row className="row-cols-2 row-cols-md-4 row-cols-xl-5">
                            {userProfileRoleList.items.map(item => {
                              switch (item.code) {
                                // case "ROLE_ECONTRACT_FEC_GUEST":
                                // case "ROLE_ECONTRACT_FEC_EMPLOYEE":
                                //   break;
                                default:
                                  return (
                                    <Col key={item.code}>
                                      <FormGroup check>
                                        <Label check>
                                          <input
                                            type="checkbox"
                                            disabled={
                                              controlFields.disabled.user_role
                                            }
                                            className="form-check-input"
                                            value={item.code}
                                            {...register("user_role")}
                                          />
                                          {item.name}
                                        </Label>
                                      </FormGroup>
                                    </Col>
                                  );
                              }
                            })}
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  )}
                  <Col>
                    {errors.user_role && (
                      <MessageFormValidate error={errors.user_role.message} />
                    )}
                  </Col>
                </Row>
              )}
            </ModalBody>
            <ModalFooter>
              <Row className="justify-content-end">
                {controlFields.display.btn_save && (
                  <Col className="col-auto">
                    <Button
                      color="primary"
                      className="btn-label"
                      type="button"
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                      disabled={isLoadingUpdate}
                    >
                      <i className="far fa-save label-icon"></i>
                      {t("form.update")}
                    </Button>
                  </Col>
                )}
              </Row>
            </ModalFooter>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
};

DetailUserProfile.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  userProfileRoleList: PropTypes.object,
  userProfileEmailDomainList: PropTypes.object,
};

DetailUserProfile.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  userProfileRoleList: {},
  userProfileEmailDomainList: {},
};

export default DetailUserProfile;
